export const formatDistance = (distance?: number) => {
  if (!distance) return '--';

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  }).format(distance);
}